/**
 * @fileOverview This file contains the implementation of the MoveToSectionMenu component used in the questionnaire module.
 * @version 1.0.0
 * @since 1.0.0
 * @author Miguel Ángel Bermea Rodríguez
 */

import React, { useEffect, useState } from 'react'
import { MenuItem, Menu } from '@mui/material'
import { GlobalVariables } from '../../globalVar';
import customAxios from '../../utils/customAxios';
import { toast } from 'react-toastify';
import { getToast } from '../../utils/toastConfig';

/**
 * MoveToSectionMenu component of a question on a questionnaire
 * @param {State} {selectedQuestion} - State of selected question of a questionnaire
 * @param {State} {selectedQuestion} - State of selected section of a questionnaire
 * @param {Object} {anchorSecMenu} - The anchor element for the section menu
 * @param {State} {openSecMenu} - The boolean state indicating wheter the sections menu is open
 * @param {Function} {handleSecMenuClose} - The function to handle closing the section menu
 * @param {Function} {getDirectoryData} - 
 * @param {Function} {getDirectoryData} - 
 * @returns {Component} MoveToSectionMenu component
 */
const MoveToSectionMenu = ({ selectedQuestion, selectedSection, anchorSecMenu, openSecMenu, handleSecMenuClose, getDirectoryData, getQuestionsData }) => {
    /**
     * State to hold the menu items
     * @type {Array}
     */
    const [menuItems, setMenuItems] = useState([]);

    /**
     * Effect to fetch possible sections when the section menu is opened
     */
    useEffect(() => {
        if (openSecMenu) {
            customAxios.get(`${GlobalVariables.getURL()}getPossibleSections/${selectedQuestion}`, {
                headers: {
                    'Authorization': 'bearer ' + localStorage.getItem('token')
                }
            })
                .then(response => {
                    setMenuItems(response.data);
                })
                .catch(error => {
                    console.error("Error en GET: ", error);
                })
        }
    }, [openSecMenu, selectedQuestion]);

    /**
     * Function to close the menu and refresh the data
     */
    function closeMenu() {
        handleSecMenuClose();
        getToast({ status: 'success', title: 'Movimiento de pregunta exitoso.' });
        getDirectoryData();
        getQuestionsData(selectedSection);
    }

    /**
     * Function to change the section of a question
     * @param {string} newSectionId - The ID of the new section
     */
    function changeToSection(newSectionId) {
        customAxios.post(`${GlobalVariables.getURL()}changeQuestionSection/${selectedQuestion}`, {
            original_section_id: selectedSection,
            new_section_id: newSectionId,
        }, {
            headers: {
                'Authorization': 'bearer ' + localStorage.getItem('token')
            }
        })
        .then((response) => {
            closeMenu();
        }, (error) => {
            console.log(error);
            getToast({ status: 'error', title: 'Error al mover la pregunta. Vuelve a intentarlo.' });
        });
    }

    /**
     * Render the MoveToSectionMenu component
     */
    return (
        <Menu
            id="section-menu"
            anchorEl={anchorSecMenu.current}
            keepMounted
            open={openSecMenu}
            onClose={handleSecMenuClose}
            PaperProps={{
                style: {
                    maxHeight: '200px',
                    overflowY: 'auto',
                },
            }}
        >
            {menuItems.map(item => (
                <MenuItem key={item.section_id} onClick={() => changeToSection(item.section_id)}>
                    {item.section_name}
                </MenuItem>
            ))}
        </Menu>
    )
}

export default MoveToSectionMenu